import Layout from '@/layout'

const bankCardRouter = {
  path: '',
  component: Layout,
  redirect: 'bank-card',
  name: '银行卡管理',
  meta: {
    title: '银行卡管理',
    icon: 'el-icon-s-home'
  },
  children: [
    {
      path: 'bank-card',
      name: 'bank-card',
      meta: {
        title: '银行卡管理'
      },
      component: () => import('@/views/bank-card')
    },
    {
      path: 'bank-card/detail',
      name: 'detail',
      meta: {
        title: '银行卡管理-详情'
      },
      component: () => import('@/views/bank-card/detail')
    },
    {
      path: 'bank-card/add',
      name: 'add',
      meta: {
        title: '银行卡管理-新增'
      },
      component: () => import('@/views/bank-card/add')
    },
    {
      path: 'bank-card/addBus',
      name: 'addBus',
      meta: {
        title: '银行卡管理-新增'
      },
      component: () => import('@/views/bank-card/addBus')
    }
  ]
}

export default bankCardRouter
